import React, { useState } from 'react';
import { ArrowUp } from 'lucide-react';
import { experienceProfile } from '../../../shared/rules/experience.mjs';
import LevelUp from '../attributes/LevelUp';
import './Experience.scss';
export default function ExperienceBar({ form }) {
  const [show, setShow] = useState(false);
  const xp = experienceProfile(form);
  return <div className="experience-dock-edge">
    <div className="experience-track" role="progressbar" aria-label="Experience to next level" aria-valuemin={0} aria-valuemax={100} aria-valuenow={Math.round(xp.progress * 100)}
      aria-valuetext={xp.next === null ? 'Maximum level' : `${xp.total.toLocaleString()} of ${xp.next.toLocaleString()} XP`}>
      <div className="experience-track__fill" style={{ width: `${xp.progress * 100}%` }} />
      <span className="experience-track__label">{xp.next === null ? 'LEVEL 20 · MAX LEVEL' : `LV ${xp.level} · ${xp.total.toLocaleString()} / ${xp.next.toLocaleString()} XP`}</span>
    </div>
    {xp.ready && <button className="experience-level-up" type="button" onClick={() => setShow(true)} aria-label={`Level up to level ${xp.level + 1}`} title={`Ready for level ${xp.level + 1}`}><ArrowUp size={20}/><span>Level up</span></button>}
    {show && <LevelUp show={show} form={form} handleClose={() => setShow(false)}/>}
  </div>;
}
